
import { defineComponent, PropType, reactive } from "vue";
export default defineComponent({
   props: {
      modelValue: {
         type: [String, Number],
         default: "",
      },
      data: {
         type: Array as PropType<any[]>,
         default: () => [],
      },
      isImg:{
         type: Boolean,
         default: false,
      },
      props: {
         type: Object,
         default: () => {
            return {
               label: "projectName",
               id: "id",
            };
         },
      },
   },
   setup() {
      return {};
   },
   /****************************************************************
    *
    *
    *
    ***************************************************************/
});
